import React, { useState } from "react";
import { CURRENCIES, getCurrency } from "@/lib/currencies";
import { ChevronDown, Globe } from "lucide-react";
import { storage } from "@/lib/storage";

export const CurrencyPicker = ({ value, onChange, compact = false }) => {
  const [open, setOpen] = useState(false);
  const cur = getCurrency(value);

  const select = (code) => {
    storage.setCurrency(code);
    onChange && onChange(code);
    setOpen(false);
  };

  return (
    <div className="relative" data-testid="currency-picker">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 px-3 py-2 rounded-full border gold-border hover:bg-[rgba(230,180,85,0.08)] transition text-sm"
        data-testid="currency-picker-trigger"
      >
        {compact ? <Globe size={14} className="text-[#E6B455]" /> : <span>{cur.flag}</span>}
        <span className="font-semibold text-[#F7E6B4]">{cur.code}</span>
        <ChevronDown size={14} className={`text-[#F7E6B4]/60 transition ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div
            className="absolute right-0 mt-2 w-64 rounded-2xl p-2 card-glass gold-glow z-50 max-h-72 overflow-y-auto"
            data-testid="currency-picker-dropdown"
          >
            {CURRENCIES.map((c) => (
              <button
                key={c.code}
                onClick={() => select(c.code)}
                className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg hover:bg-[rgba(230,180,85,0.08)] transition text-left ${
                  c.code === value ? "bg-[rgba(230,180,85,0.06)]" : ""
                }`}
                data-testid={`currency-opt-${c.code}`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-xl">{c.flag}</span>
                  <div>
                    <div className="text-sm font-semibold text-[#F7E6B4]">{c.code}</div>
                    <div className="text-xs text-[#F7E6B4]/55">{c.name}</div>
                  </div>
                </div>
                <span className="text-[#E6B455] font-medium">{c.symbol}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
